import React from "react";
import PropTypes from "prop-types";
import { Button } from "@learningblocks/shared-components/lib/Button";
import { useTranslation } from "react-i18next";

import "./style.scss";

const TRANSLATION_KEY = {
  Start: "Start.string",
  Stop: "Stop.string",
};

export function StartStopButton(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  const commonClassName = "mc_settings_startstop_button";

  const stopBtnClassName = props.disabled
    ? `${commonClassName} mc_invalidBtn--stop`
    : `${commonClassName} mc_button--stop`;

  const startBtnClassName = props.disabled
    ? `${commonClassName} mc_invalidBtn--start`
    : `${commonClassName} mc_button--start`;

  return (
    <div className="mc_settings_startstop">
      <Button onClick={props.onClickStop} className={stopBtnClassName}>
        {t(TRANSLATION_KEY.Stop)}
      </Button>
      <Button onClick={props.onClickStart} className={startBtnClassName}>
        {t(TRANSLATION_KEY.Start)}
      </Button>
    </div>
  );
}

StartStopButton.propTypes = {
  /**
   * callback for when stop button is clicked
   */
  onClickStop: PropTypes.func,
  /**
   * callback for when start butto is pressed
   */
  onClickStart: PropTypes.func,
  /**
   * specifies if buttons are disabled
   */
  disabled: PropTypes.bool,
};

StartStopButton.defaultProps = {
  className: "",
};
